import {
  KeyboardAvoidingView,
  Platform,
  SafeAreaView,
  ScrollView,
  StyleSheet,
} from 'react-native';
import { SelectedSetsData } from '@/components/SetsSelectedData';
import { TemplateChoiceBanner } from '@/components/TemplateChoiceBanner';
import { useSentenceSetContext } from '@/contexts/SentenceSetContext/useSentencesetContext';
import { Filter } from './Filter';
import { Header } from './Header';

const innerStyles = StyleSheet.create({
  container: { flex: 1 },
  scrollStyle: { flex: 1, gap: 20, margin: 28 },
});

export function SetsSelectedWrapper({ props }) {
  const {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    scrollViewRef,
    template,
  } = useSentenceSetContext();
  const propz = {
    data,
    selectedData,
    changeSelectedData,
    patientId,
    page,
    changePage,
    limitModal,
    changeLimitModal,
    setId,
    editData,
    dataKeyName,
    apiKeyName,
    dynamicName,
    template,
    props,
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : undefined}
      style={{ flex: 1 }}
      keyboardVerticalOffset={Platform.OS === 'ios' ? 80 : 0}
    >
      <SafeAreaView style={innerStyles.container}>
        <Header props={props} />
        <ScrollView ref={scrollViewRef} style={innerStyles.scrollStyle}>
          {!setId && !props.route.params.templateMode && (
            <TemplateChoiceBanner type="Sentence" />
          )}
          <Filter />
          <SelectedSetsData type="sentence" {...propz} />
        </ScrollView>
      </SafeAreaView>
    </KeyboardAvoidingView>
  );
}
